'use strict';

var React = require('react');

var SvgLockMajor = function SvgLockMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6v2h-1.5a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5h-1.5v-2a6 6 0 0 0-12 0zm6-4a4 4 0 0 0-4 4v2h8v-2a4 4 0 0 0-4-4zm1 14v-4h-2v4h2z"
  }));
};

exports.SvgLockMajor = SvgLockMajor;
